
/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */
import React from "react";

export interface ICambriaRouteParameterOptions {};

export interface ICambriaContext {}

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const CambriaContext = React.createContext<ICambriaContext>({} as ICambriaContext);

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default CambriaContext;